import {type ExtractRouteParams} from 'react-router';

import {type QueryParams} from './query-params';
import {type GenericRouteMap} from './generic-route';
import {type PathGenerationArgs} from './path-generation-args';
import {type PathUnion} from './route-config-path';

/**
 * Helper function for picking query parameters out of params while still maintaining type safety.
 */
export const extractParams = <T extends PathUnion<GenericRouteMap>>([path, params]: PathGenerationArgs<T>) => {
    // Extract query params if they exist
    const queryParams = params && 'queryParams' in params ? params.queryParams : undefined;

    // Omit queryParams from params if they exist
    let routeParams = params;
    if (params && 'queryParams' in params) {
        const {queryParams: omittedQueryParams, ...rest} = params;
        routeParams = rest;
    }

    // Coerce Typescript by helping with tuple type
    return [path, routeParams, queryParams] as [T, ExtractRouteParams<T>, QueryParams['queryParams']];
};
